import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { MatchingItemMasterCommand, Yarn, YarnSearchRequest, YarnSearchSeveralRequest } from '../../models/yarns/yarn';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';
import { ItemMaster } from '../../models/item-master';

@Injectable({
  providedIn: 'root',
})
export class YarnProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/yarn';

  public getYarnById(id: string): Observable<ApiResponse<PaginatedApiResponse<Yarn>>> {
    return this.httpClient.get<ApiResponse<PaginatedApiResponse<Yarn>>>(`${this.baseUrl}/${id}`);
  }

  public getYarnByCode(code: string): Observable<ApiResponse<PaginatedApiResponse<Yarn>>> {
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Yarn>>>(`${this.baseUrl}/search`, {
      code,
    });
  }

  public createYarn(yarn: Yarn): Observable<ApiResponse<Yarn>> {
    return this.httpClient.post<ApiResponse<Yarn>>(this.baseUrl, yarn);
  }

  public updateYarn(yarn: Yarn): Observable<ApiResponse<Yarn>> {
    return this.httpClient.put<ApiResponse<Yarn>>(`${this.baseUrl}/${yarn.id}`, yarn);
  }

  public getItemMastersByYarnCode(command: MatchingItemMasterCommand[]): Observable<ApiResponse<Record<string, ItemMaster | null>>> {
    return this.httpClient.post<ApiResponse<Record<string, ItemMaster | null>>>(`${this.baseUrl}/yarn-code/batch/item-master`, command);
  }

  public searchYarns(searchCriteria: YarnSearchRequest, matchAny = false): Observable<ApiResponse<PaginatedApiResponse<Yarn>>> {
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Yarn>>>(`${this.baseUrl}/search?matchAny=${matchAny}`, searchCriteria);
  }

  public search(
    searchCommand: YarnSearchRequest,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder?: number,
  ): Observable<ApiResponse<PaginatedApiResponse<Yarn>>> {
    let url = `${this.baseUrl}/search?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (sortField) {
      url += `&sortField=${sortField}&sortOrder=${sortOrder ?? -1}`;
    }
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Yarn>>>(url, searchCommand);
  }

  public searchSeveral(body: YarnSearchSeveralRequest): Observable<ApiResponse<Yarn[]>> {
    return this.httpClient.post<ApiResponse<Yarn[]>>(`${this.baseUrl}/search-several`, body);
  }
}
